<template lang="es">
    <div class="todo">
        <line-chart v-if="visible" 
        :receta="trabajoCargado.detalles"
        :setpointMaximo="setpointMaximo" 
        :chartData="datosGrafico"></line-chart>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import LineChart from '@/components/modulos/LineChart.vue'
export default {
    components: {
        LineChart
    },
    props: {
        zonas: Array,
        visible: Boolean,
        detalles: Array,
        instantanea: Object,
        proprecalcular:Boolean,
        setpointMaximo:Number,
        medicion: Number,
    },
    data() {
        return {
            //cada cuánto vamos a leer en segundos
            //Se emplea para calcular el número de puntos que vamos a poner en la gráfica
            deltaTime: 1,
            current_labels: [],
            current_setpoint_data: [],
            all_datasets: []

        }
    },
    // mounted(){
    //     if(!this.zonas)
    //      this.recorrido(JSON.parse(JSON.stringify(this.detalles)))
    // },
    methods: {
        padZero(number) {
            return number < 10 ? `0${number}` : number;
        }
    },
    watch: {
        proprecalcular(){
            console.log("proprecalcular",this.proprecalcular)
            if (this.proprecalcular && this.zonas.length > 0) {
                // this.recalcularPorZonas();
                this.$emit('cargados')
            }
        },
        detalles: {
            immediate: true,
            deep: true,
            handler(newVal) {

                if (this.detalles === undefined) return
                this.current_labels = [],
                this.current_setpoint_data = []
                if (this.detalles.length > 0) {
                    this.recalcular();
                }
            }
        },
        zonas: {
            immediate: true,
            deep: true,
            handler(newVal) {
                //console.log("CAMBIO EN ZONAS!",newVal)
                // if (this.zonas === undefined) return
                // this.current_labels = [],
                //     this.current_setpoint_data = []
                // if (this.zonas.length > 0) {
                //     this.recalcularPorZonas();
                // }

            }
        }
    },
    computed: {
        ...mapState(['inicio_ciclo','trabajoCargado']),
       
        
        datosGrafico() {
            // let labels = this.current_labels
            // let datasets = this.all_datasets
            return { labels:this.labels, datasets:this.datasets }
        },
        labels() {
            if (this.zonas) {
                const diasVistos = [];
                return this.zonas[4].map((v) => {
                    const [dia, hora] = v.x.split(' - ');
                    let indiceDia = diasVistos.indexOf(dia);
                    if (indiceDia === -1) {
                        diasVistos.push(dia);
                        indiceDia = diasVistos.length - 1;
                    }
                    return indiceDia > 0 ? `Día ${indiceDia + 1} ${hora}` : hora;
                });
            }
            return this.current_labels;
        },
        datasets(){
            let datos = []
            if(this.zonas){

                const numPuntos = this.zonas[4].length;
                const indicePorX = new Map(this.zonas[4].map((v, i) => [v.x, i]));

                const construirSerie = (zona) => {
                    const serie = new Array(numPuntos).fill(null);
                    zona.forEach(element => {
                        const i = indicePorX.get(element.x);
                        if (i !== undefined) serie[i] = element.y;
                    });
                    return serie;
                };

                let setpoint_data_zona_1 = construirSerie(this.zonas[1]);
                let setpoint_data_zona_2 = construirSerie(this.zonas[2]);
                let setpoint_data_zona_agua = construirSerie(this.zonas[3]);
                let setpoint_data_setpoint = construirSerie(this.zonas[4]);
                let data_zona_1_contacto = construirSerie(this.zonas[5]);
                let data_zona_2_contacto = construirSerie(this.zonas[6]);

                // DISTINAS CABECERAS SEGÚN SI SE HA MEDIDO CON LOS MEDIDORES DE CONTACTO O NO
                if(this.medicion == 2){
                    datos = [
                        {
                            label: 'Zona 1 aereo',
                            backgroundColor: 'rgba(24, 147, 2, 0.2)',
                            borderColor: 'rgba(24, 147, 2, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_1
                        },{
                            label: 'Zona 2 aereo',
                            backgroundColor: 'rgba(255, 175, 0, 0.2)',
                            borderColor: 'rgba(255, 175, 0, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_2
                        },{
                            label: 'Zona 1 contacto',
                            backgroundColor: 'rgba(24, 200, 100, 0.2)',
                            borderColor: 'rgba(24, 200, 100, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: data_zona_1_contacto
                        },{
                            label: 'Zona 2 contacto',
                            backgroundColor: 'rgba(255, 120, 0, 0.2)',
                            borderColor: 'rgba(255, 120, 0, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: data_zona_2_contacto
                        },{
                            label: 'Zona agua',
                            backgroundColor: 'rgba(44, 112, 237, 0.2)',
                            borderColor: 'rgba(44, 112, 237, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_agua
                        },{
                            label: 'Setpoint',
                            backgroundColor: 'rgba(11, 22, 33, 0.4)',
                            borderColor: 'rgba(11, 22, 33, 0.4)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_setpoint
                        },
                    ]
                }else{
                    datos = [
                        {
                            label: 'Zona 1 aereo',
                            backgroundColor: 'rgba(24, 147, 2, 0.2)',
                            borderColor: 'rgba(24, 147, 2, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_1
                        },{
                            label: 'Zona 2 aereo',
                            backgroundColor: 'rgba(255, 175, 0, 0.2)',
                            borderColor: 'rgba(255, 175, 0, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_2
                        },{
                            label: 'Zona agua',
                            backgroundColor: 'rgba(44, 112, 237, 0.2)',
                            borderColor: 'rgba(44, 112, 237, 1)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_zona_agua
                        },{
                            label: 'Setpoint',
                            backgroundColor: 'rgba(11, 22, 33, 0.4)',
                            borderColor: 'rgba(11, 22, 33, 0.4)',
                            borderWidth: 2,
                            pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                            data: setpoint_data_setpoint
                        },
                    ]
                }
            }
            else{
                
                datos = [
                    {
                        label: 'Consigna',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 3,
                        pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                        data: this.current_setpoint_data
                    }]
            }
            return datos
        }
    },
    methods: {

        recorrido(datos) {
            //console.log('datos',datos)
            let last_setpoint = null
            let last_time = '00:00:00'
            datos.forEach((detalle, index) => {

                //Poner tantos puntos como deltaTimes haya en este segmento
                const diferencia_tiempos_minutos = this.$diferencia_tiempos_minutos(detalle.hora_fin, detalle.hora_inicio)
                //Calcular pendiete como
                //(y1-y0)/diferencia_tiempos = (setpoint-last_setpoint)/diferencia_tiempos_minutos
                const pendiete_actual = (last_setpoint) ? (parseFloat(detalle.setpoint) - last_setpoint) / diferencia_tiempos_minutos : 0;
                const numero_puntos_actual = diferencia_tiempos_minutos / this.deltaTime

                if (numero_puntos_actual == 0) {
                    let hora_inicio = detalle.hora_fin.split(':')[0] + ':' + detalle.hora_fin.split(':')[1]
                    this.current_labels.push(hora_inicio)
                    this.current_setpoint_data.push(parseFloat(detalle.setpoint))
                }
                for (let i = 0; i < numero_puntos_actual; i++) {
                    const momento_actual = this.$sumar_minutos_a_hora(this.deltaTime, last_time)
                    //ya=y_a-1+m*dt
                    const setpoint_actual = last_setpoint + pendiete_actual * this.deltaTime;

                    this.current_labels.push(momento_actual)
                    this.current_setpoint_data.push(setpoint_actual)
                    last_time = momento_actual;
                    last_setpoint = setpoint_actual
                }
                last_setpoint = parseFloat(detalle.setpoint);
                last_time = detalle.hora_fin
            });
        },
        recalcular() {
            console.log("recalculando.....")
            if (this.detalles.length > 0) {

                this.recorrido(JSON.parse(JSON.stringify(this.detalles)))


                this.all_datasets = [
                    {
                        label: 'Consigna',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        borderColor: 'rgba(75, 192, 192, 1)',
                        borderWidth: 3,
                        pointRadius: 0, //No pintar los puntos (para que solo se vea la linea
                        data: this.current_setpoint_data
                    }]
            }
        }
    },
}
</script>
<style scoped>
.todo {
    background-color: rgba(50, 155, 59, 0.103);
    width: 100%;
    /* Ancho del 100% del viewport */
    height: 100%;
    /* Altura del 100% del viewport */
}

.h-100 {
    height: 100%;
}
</style>